// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Library-Tax-TaxDetail-__style___2O1Cc","wrapper":"app-pages-Library-Tax-TaxDetail-__style___8v0vX","title":"app-pages-Library-Tax-TaxDetail-__style___2hq62","footer":"app-pages-Library-Tax-TaxDetail-__style___1FnBw","btn-cancel":"app-pages-Library-Tax-TaxDetail-__style___3YxxY","btn-save":"app-pages-Library-Tax-TaxDetail-__style___1C2GI"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Tax/TaxDetail/style.css
// module id = 836
// module chunks = 0